
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#DC3545","d":"M7.884 4.677c1.192.03 2.507-.063 3.615.05.742.804-.319 1.824-1.528 1.625.492.838.136 2.127-.356 2.64-1.393 1.447-4.35-.036-5.346 1.42-.543-.416-.686-1.777-.254-2.436.252.787 2.562 1.013 2.444-.05-.091-.806-2.018-.518-2.495-.153-.066-.503-.515-.944-.407-1.42.103-.455.611-.297.865-.66-.11-.286-.539.092-.611 0-.01-1.313 1.743-.869 2.902-1.016.222.41 1 .598 1.17 0zm4.474 12.505c-.268-3.524 3.132-4.047 3.399-7.096.199-2.258-1.591-4.133-3.501-4.646.03-.354-.109-.537-.203-.766 3.753-.144 6.595 2.76 6.343 6.535-.1 1.497-.872 3.369-2.03 4.135-1.222.809-2.71 1.129-4.008 1.838zm-.391.266c-.727.401-1.55.995-2.134 1.583-.148.149-.525.811-.66.818-.151.008-.732-.884-.813-1.073-.99-2.27.625-4.147 1.829-5.57 1.016-1.2 2.108-2.38 2.287-3.985.142-1.28-.313-2.357-.915-2.861.166-.159.36-.556.507-.563 1.628.513 2.89 1.615 3.2 3.322.68 3.724-4.135 4.455-3.301 8.329zm-.785-10.933h.101c.598.618.93 1.248.864 2.336-.193 3.182-4.08 4.625-4.369 7.922-.133 1.527.461 2.411 1.169 3.25-.306.466-.575 1.363-.305 2.082-2.122-1.404-4.248-3.146-4.47-6.043-.194-2.501 1.345-3.746 2.692-4.722 1.668-1.211 4.084-1.89 3.658-4.622.255-.032.474-.1.66-.203zM6.319 4.36c-.064-.216.202-.386.356-.518.164-.14.38-.336.612-.414.426-.143.97-.05 1.427-.207.408-.14.625-.591 1.07-.88.956-.618 2.582-.467 3.722-.26 1.285.235 2.132.689 2.957 1.347-1.691-.957-4.838-.53-5.913.88-1.356.072-2.805.05-4.231.052zm5.02-.022c-.059-.176.606-.563.966-.716 3.912-1.668 7.84 2.367 8.136 5.779.223 2.562-1.328 3.874-2.695 5.114.59-1.224 1.227-2.593 1.018-4.5-.383-3.474-3.46-6.075-7.426-5.677z"}})])
          )
        }
      }
    